import type { IconClassName } from '../Icon';

import Badge from './Badge';
import type { BadgeProps } from './Badge';

export type IconBadgeProps = Omit<BadgeProps, 'children' | 'outline' | 'invert' | 'fullWidth' | 'title'> & {
  icon: IconClassName
};

/**
 * Icon only variant of the generic Badge.
 * Background color driven by @param color. The shape of the badge is by default a cirlce, however can be made into a box by explicitly passing in @param shape
 */
const IconBadge = ({
  color,
  icon,
  size = 'micro',
  shape = 'circle',
}: IconBadgeProps) => (
  <Badge
    color={color}
    icon={icon}
    size={size}
    shape={shape}
  />
);

export default IconBadge;
